module.exports = __webpack_public_path__ + "static/media/grid-icon.4e7dda25.svg";